import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';

interface HeaderIconProps extends SvgIconProps {
  selected: boolean;
  baseColor?: string;
}

const AdminIcon: React.FC<HeaderIconProps> = (props: HeaderIconProps) => {
  const {selected, baseColor, ...svgProps} = props;

  return (
    <SvgIcon
      {...svgProps}
      component={BuildCircleIcon}
      style={{
        fillOpacity: props.baseColor ? '1' : props.selected ? '1' : '0.5',
        color: props.baseColor && !props.selected ? props.baseColor : '#FFFFFF',
      }}
    />
  );
};

export default AdminIcon;
